import mz from '../../../../../assets/images/newLegend/mz.png'

import cpz from '../../../../../assets/images/newLegend/cpz.png'

import tyz from '../../../../../assets/images/newLegend/tyz.png'

import tyx from '../../../../../assets/images/newLegend/tyx.png'

import tyg from '../../../../../assets/images/newLegend/tyg.png'

import jqz from '../../../../../assets/images/newLegend/jqz.png';

import psz from '../../../../../assets/images/newLegend/psz.png';

import gzz from '../../../../../assets/images/newLegend/gzz.png';

import js from '../../../../../assets/images/newLegend/wallroom.png';

import xlkj from '../../../../../assets/images/newLegend/xlkj.png';

import mjcs from '../../../../../assets/images/newLegend/mjcs.png';

import sggd from '../../../../../assets/images/newLegend/sggd.png';

import danger1 from '../../../../../assets/images/legend/danger1.png'
import danger2 from '../../../../../assets/images/legend/danger2.png'
import danger3 from '../../../../../assets/images/legend/danger3.png'
import danger4 from '../../../../../assets/images/legend/danger4.png'
import danger from '../../../../../assets/images/newLegend/wxy0.png'
import jqzqy from '../../../../../assets/images/newLegend/jqzqy.png'
import yhqqy from '../../../../../assets/images/newLegend/yhqqy.png'
import gdrqqy from '../../../../../assets/images/newLegend/gdrqqy.png'
import dygd from '../../../../../assets/images/newLegend/dygd.png'
import gygd from '../../../../../assets/images/newLegend/gygd.png'
import cgygd from '../../../../../assets/images/newLegend/cgygd.png'

//门站0-储配站1-调压站2-调压箱3-调压柜4-加气站5-配送站6-灌裝站7-井室8-相邻空间9-密集场所10-施工工地11
const newList = [mz,cpz, tyz, tyx, tyg, jqz, psz, gzz, js, xlkj, mjcs, sggd]

const dangerList = [danger1,danger2,danger3,danger4]

export const getIconList = (type) => {
    return newList
}

export const getKaBoxIcon = (status) =>{
   return newList
}
export const getDangerLevelIcon = (level) => {
    if(level===1){
        return dangerList[0]
    }else if (level===2){
        return dangerList[1]
    }else if (level===3){
        return dangerList[2]
    }else{
        return dangerList[3]
    }
}
export const getCompanyTypeIcon = (type) => {
    if(type==='001'){
        return gdrqqy
    }else if(type==='002'){
        return yhqqy
    }else{
        return jqzqy
    }
}
export const pipeIcon = [
    { name: '低压管道', icon: dygd},
    { name: '中压管道', icon: gygd},
    { name: '次高压管道', icon: cgygd},
    { name: '门站', icon: mz },
    { name: '储配站', icon: cpz },
    { name: '调压站', icon: tyz },
    { name: '调压箱', icon: tyx },
    { name: '调压柜', icon: tyg },
    { name: '井室', icon: js },
    { name: '相邻空间', icon: xlkj },
    { name: '密集场所', icon: mjcs },
    { name: '施工工地', icon: sggd },
    { name: '危险源', icon: danger},
    { name: '管道燃气企业', icon: gdrqqy},
]
export const addGasIcon = [
    { name: '加气站', icon: jqz },
    { name: '加气站企业', icon: jqzqy},
]
export const liauerfied = [

    { name: '液化气企业', icon: yhqqy},
    { name: '配送站', icon: psz },
    { name: '灌裝站', icon: gzz },
]
export const legend = [
    ...pipeIcon,
    ...addGasIcon,
    ...liauerfied
]

// export const themeArr = [
//     {
//         id: 0,
//         label: '场站专题',
//         text: '场站专题展示新泰市城市燃气不同类型场站分布，及供气量、告警等监测情况。可直观了解燃气场站运行状态，为城市燃气安全高效供应提供有力参考。',
//         src: themeImg1,
//     },
//     {
//         id: 1,
//         label: '泄漏监测专题',
//         text: '聚焦井室、相邻空间和密集场所，监测泄漏、气体浓度与告警信息，还检测管线。确保及时发现隐患，保障燃气安全运行，为民众生活和公共安全提供有力保障。',
//         src: themeImg2,
//     },
//     {
//         id: 2,
//         label: '安全专题',
//         text: '呈现燃气各类监测设备告警状况，关注周边施工情况及钢瓶检查情况、隐患信息。为保障燃气安全，提供全面的监测视角，守护民众生活与公共安全。',
//         src: themeImg3,
//     },
//     {
//         id: 3,
//         label: '液化石油气专题',
//         text: '直观展示钢瓶数量及配送状态。车辆运输情况一目了然，确保高效配送。同时，深入分析入户安检，为用户安全用气把关。通过数据与图表，呈现液化气供应全流程，保障安全稳定的用气环境。',
//         src: themeImg3,
//     },
//     {
//         id: 4,
//         label: '数据监控(管道气)专题',
//         text: '方便监管人员可实时掌握管道燃气场站、井室、相邻空间和密集场所监控数据上传情况，为燃气安全监管提供有力支持，保障相关区域安全。',
//         src: themeImg3,
//     },
//     {
//         id: 5,
//         label: '数据监控(液化气)专题',
//         text: '能让相关人员及时知晓钢瓶充装、配送、出入库、随瓶安检数据的上传情况，同时掌握企业在线运营车辆覆盖率状况，为钢瓶安全管理和企业运营监管提供有效依据。',
//         src: themeImg3,
//     }
// ]

export const themeArr = [
    {
        id: 6,
        label: '区域概览',
        text: '',
    },
    {
        id: 13,
        label: '管道燃气',
        text: ''
    },
    {
        id: 7,
        label: '供气保障',
        text: '',
    },
    {
        id: 2,
        label: '运行安全',
        text: '呈现燃气各类监测设备告警状况，关注周边施工情况及钢瓶检查情况、隐患信息。为保障燃气安全，提供全面的监测视角，守护民众生活与公共安全。',
    },
    {
        id: 0,
        label: '场站运行',
        text: '场站专题展示新泰市城市燃气不同类型场站分布，及供气量、告警等监测情况。可直观了解燃气场站运行状态，为城市燃气安全高效供应提供有力参考。',
    },
    {
        id: 1,
        label: '泄漏监测',
        text: '聚焦井室、相邻空间和密集场所，监测泄漏、气体浓度与告警信息，还检测管线。确保及时发现隐患，保障燃气安全运行，为民众生活和公共安全提供有力保障。',
    },
    {
        id: 8,
        label: '服务监管',
        text: '',
    },
    {
        id: 9,
        label: '户内风险',
        text: '',
    },
    {
        id: 3,
        label: '液化石油气',
        text: '直观展示钢瓶数量及配送状态。车辆运输情况一目了然，确保高效配送。同时，深入分析入户安检，为用户安全用气把关。通过数据与图表，呈现液化气供应全流程，保障安全稳定的用气环境。',
    },
    {
        id: 10,
        label: '物联告警',
        text: '',
    },
    // {
    //     id: 11,
    //     label: '应急指挥',
    //     text: '',
    // },
    {
        id: 4,
        label: '管道燃气数据监控',
        text: '方便监管人员可实时掌握管道燃气场站、井室、相邻空间和密集场所监控数据上传情况，为燃气安全监管提供有力支持，保障相关区域安全。',
    },
    {
        id: 5,
        label: '液化石油气数据监控',
        text: '能让相关人员及时知晓钢瓶充装、配送、出入库、随瓶安检数据的上传情况，同时掌握企业在线运营车辆覆盖率状况，为钢瓶安全管理和企业运营监管提供有效依据。',
    },
    {
        id: 11,
        label: '安全风险评估',
        text: '',
    },
]

export const themeArr1 = [
    {
        id: 1,
        label: '区域概览',
    },
    {
        id: 13,
        label: '管道燃气',
    },
    {
        id: 14,
        label: '液化石油气',
    },
    {
        id: 15,
        label: '汽车加气站',
    },
    // {
    //     id: 2,
    //     label: '供气保障',
    // },
    {
        id: 3,
        label: '运行安全',
    },
    {
        id: 4,
        label: '服务监管',
    },
    // {
    //     id: 5,
    //     label: '场站运行',
    // },
    {
        id: 6,
        label: '泄漏监测',
    },
    {
        id: 7,
        label: '户内风险',
    },
    // {
    //     id: 8,
    //     label: '液化石油气',
    // },
    {
        id: 9,
        label: '物联告警',
    },
    {
        id: 10,
        label: '管道燃气数据监控',
    },
    {
        id: 11,
        label: '液化石油气数据监控',
    },
    {
        id: 12,
        label: '安全风险评估',
    },
]

/**
 * label 名称
 * value checkbox 的v-model的值
 * showList对应的主题id，存在则checkbox显示
 */
export const checkboxList = [
    {
        label:'门站',
        value:'doorStation',
        showList:[1,2,3,5,6,7,9,10,12,13],
        layers:['doorIconLayer','doorLabelLayer']
    },
    {
        label:'调压站',
        value:'kaStation',
        showList:[1,2,3,5,6,7,9,10,12,13],
        layers:['kaIconLayer','kaLabelLayer']
    },
    {
        label:'调压箱',
        value:'kaBox',
        showList:[1,2,3,4,5,6,7,9,10,12,13],
        layers:['kaBoxIconLayer','kaBoxLabelLayer']
    },
    {
        label:'调压柜',
        value:'kaArk',
        showList:[1,2,3,4,5,6,7,9,10,12,13],
        layers:['kaArkIconLayer','kaArkLabelLayer']
    },
    {
        label:'配送站',
        value:'supplyStation',
        showList:[1,2,3,5,6,7,8,9,11,12,14],
        layers:['supplyIconLayer','supplyLabelLayer']
    },
    {
        label:'灌裝站',
        value:'canningStation',
        showList:[1,2,3,5,6,7,8,9,11,12,14],
        layers:['canningIconLayer','canningLabelLayer']
    },
    {
        label:'储配站',
        value:'CPStation',
        showList:[1,2,3,5,6,7,9,10,12,13],
        layers:['cpIconLayer','cpLabelLayer']
    },
    {
        label:'加气站',
        value:'addAir',
        showList:[1,2,3,5,6,7,9,12,15],
        layers:['addAirIconLayer','addAirLabelLayer']
    },
    {
        label:'井室',
        value:'wellRoom',
        showList:[1,2,3,5,6,7,9,10,12,13],
        layers:['wallIconLayer','wallLabelLayer']
    },
    {
        label:'相邻空间',
        value:'adjacentSpace',
        showList:[1,2,3,5,6,7,9,10,12,13],
        layers:['adjSpaceIconLayer','adjSpaceLabelLayer']
    },
    {
        label:'密集场所',
        value:'densePlace',
        showList:[1,2,3,5,6,7,9,10,12,13],
        layers:['densePlaceIconLayer','densePlaceLabelLayer']
    },
    {
        label:'配送车辆',
        value:'truck',
        showList:[1,3,4,7,8,11,12,14],
        layers:['truckLayer']
    },
    {
        label:'管线',
        value:'pipeline',
        showList:[1,2,3,4,5,6,7,9,10,12,13],
        layers:['pipelineLayer','lineFlowLayer']
    },
    {
        label:'施工工地',
        value:'construction',
        showList:[1,3,7,9,12],
        layers:['constructionIconLayer','constructionLabelLayer']
    },
    {
        label:'危险源',
        value:'dangerSource',
        showList:[1,3,7,12,13],
        layers:['dangerSourceLayer','dangerSourceLabelLayer']
    },
    {
        label:'风险评估',
        value:'assess',
        showList:[1,3,7,12],
        layers:['regionRangeLayer','regionLineLayer']
    },
    {
        label:'楼宇',
        value:'building',
        showList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
        layers:[]
    },
    {
        label:'卫星图',
        value:'satellite',
        showList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
        layers:[]
    },
    {
        label:'企业',
        value:'company',
        showList:[1,2,3,4,8,9,12,13,14,15],
        layers:['companyIconLayer','companyLabelLayer']
    },
]



export const targetData = [
    {
        label: '温度指标', checkAll: false, indeterminate: false,
        children: [
            { label: '1#出站温度', value: 'outTemperature1', checked: false },
            { label: '2#出站温度', value: 'outTemperature2', checked: false },
            { label: '3#出站温度', value: 'outTemperature3', checked: false },
            { label: '1#入站温度', value: 'inTemperature1', checked: false },
            { label: '2#入站温度', value: 'inTemperature2', checked: false },
            { label: '3#入站温度', value: 'inTemperature3', checked: false },
        ]
    },
    {
        label: '压力指标', checkAll: false, indeterminate: false,
        children: [
            { label: '1#出站压力', value: 'outPressure1', checked: false },
            { label: '2#出站压力', value: 'outPressure2', checked: false },
            { label: '3#出站压力', value: 'outPressure3', checked: false },
            { label: '1#入站压力', value: 'inPressure1', checked: false },
            { label: '2#入站压力', value: 'inPressure2', checked: false },
            { label: '3#入站压力', value: 'inPressure3', checked: false },
        ]
    },
    {
        label: '瞬时流量指标', checkAll: false, indeterminate: false,
        children: [
            { label: '1#出站流量', value: 'outSsflow1', checked: false },
            { label: '2#出站流量', value: 'outSsflow2', checked: false },
            { label: '3#出站流量', value: 'outSsflow3', checked: false },
            { label: '1#入站流量', value: 'inSsflow1', checked: false },
            { label: '2#入站流量', value: 'inSsflow2', checked: false },
            { label: '3#入站流量', value: 'inSsflow3', checked: false },
        ]
    },
]


export const BMPGL = (ak) => {
    if (!ak) {
        ak = 'oLf54HhrIy1vAVKRrukSBiFPEHQPOkrA'
    }
    return new Promise(function (resolve, reject) {
        window.init = function () {
            // eslint-disable-next-line
            resolve(BMapGL)
        }
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=init`
        script.onerror = reject
        document.head.appendChild(script)
    })
}


export const getText = (element, arr) => {
    let str = element.name
    for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].length; j++) {
            if (j % 3 == 0) {
                str += '\n'
            }

            // let value = element[arr[i][j].value]?element[arr[i][j].value]+' ':'- '
            let value = ''

            // if(arr[i][j].label.includes('温度')){
            //     value = getTemp() +' ℃ '
            // }else if(arr[i][j].label.includes('压力')){
            //     value = getPressure() +' MPa '
            // }else if(arr[i][j].label.includes('流量')){
            //     value = getFlow() + ' m³/h '
            // }
            // str+=arr[i][j].label+' : '+value


            value = element[arr[i][j].value] ? element[arr[i][j].value] + ' ' : '- '
            if (arr[i][j].label.includes('温度')) {
                value += ' ℃ '
            } else if (arr[i][j].label.includes('压力')) {
                value += ' MPa '
            } else if (arr[i][j].label.includes('流量')) {
                value += ' m³/h '
            }
            str += arr[i][j].label + ' : ' + value
        }
    }
    return str
}
const getTemp = () => {
    return Math.floor(Math.random() * (36 - 22 + 1)) + 22
}
const getPressure = () => {
    return Math.floor(Math.random() * (800 - 240 + 1)) + 240
}

const getFlow = () => {
    return Math.floor(Math.random() * (3000 - 800 + 1)) + 800
}

export const stationOptions = [
    {
        value: '001',
        label: '门站'
    },
    {
        value: '002',
        label: '储配站'
    },
    {
        value: '003',
        label: '调压站'
    },
    {
        value: '004',
        label: '调压箱'
    },
    // {
    //     value:'005',
    //     label:'液化气场站'
    // },
    {
        value: '006',
        label: '加气站'
    },
    {
        value: '007',
        label: '调压柜'
    },
    // {
    //     value:'008',
    //     label:'其他场站'
    // },
    {
        value: '009',
        label: '配送站'
    },
    {
        value: '010',
        label: '灌裝站'
    },
]

export const options = [
    {
        value: '001',
        label: '门站'
    },
    {
        value: '002',
        label: '储配站'
    },
    {
        value: '003',
        label: '调压站'
    },
    {
        value: '004',
        label: '调压箱'
    },
    // {
    //     value:'005',
    //     label:'液化气场站'
    // },
    {
        value: '006',
        label: '加气站'
    },
    {
        value: '007',
        label: '调压柜'
    },
    // {
    //     value:'008',
    //     label:'其他场站'
    // },
    {
        value: '009',
        label: '配送站'
    },
    {
        value: '010',
        label: '灌裝站'
    },
    {
        value: 1,
        label: '井室'
    },
    {
        value: 2,
        label: '相邻空间'
    },
    {
        value: 3,
        label: '密集场所'
    },
    {
        value: 4,
        label: '企业'
    },
    {
        value: 5,
        label: '施工工地'
    },
    {
        value: 6,
        label: '危险源'
    },
    {
        value: 7,
        label: '配送车辆'
    }
]

export const getLineColor = (name) =>{
        if(name.includes('高压')){
            return '#eee20c'
        }else if(name.includes('中压')){
            return '#fc9402'
        }else{
            return '#05c1ea'
        }
}


/**
 *  判断经纬度是否超出国境
 */
function isLocationOutOfChina (latitude, longitude) {
    if (longitude < 72.004 || longitude > 137.8347 || latitude < 0.8293 || latitude > 55.8271)
        return true
    return false
}

/**
 *  将WGS-84(国际标准)转为GCJ-02(火星坐标):
 */
function transformFromWGSToGCJ (latitude, longitude) {
    var lat = ""
    var lon = ""
    var ee = 0.00669342162296594323
    var a = 6378245.0
    var pi = 3.14159265358979324

    if (isLocationOutOfChina(latitude, longitude)) {
        lat = latitude
        lon = longitude
    } else {
        var adjustLat = transformLatWithXY(longitude - 105.0, latitude - 35.0)
        var adjustLon = transformLonWithXY(longitude - 105.0, latitude - 35.0)
        var radLat = latitude / 180.0 * pi
        var magic = Math.sin(radLat)
        magic = 1 - ee * magic * magic
        var sqrtMagic = Math.sqrt(magic)
        adjustLat = (adjustLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi)
        adjustLon = (adjustLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi)
        latitude = latitude + adjustLat
        longitude = longitude + adjustLon
    }
    return { latitude: latitude, longitude: longitude }

}
/**
 *  将GCJ-02(火星坐标)转为百度坐标:
 */
export function transformFromGCJToBaidu (latitude, longitude) {
    var pi = 3.14159265358979324 * 3000.0 / 180.0

    var z = Math.sqrt(longitude * longitude + latitude * latitude) + 0.00002 * Math.sin(latitude * pi)
    var theta = Math.atan2(latitude, longitude) + 0.000003 * Math.cos(longitude * pi)
    var a_latitude = (z * Math.sin(theta) + 0.006)
    var a_longitude = (z * Math.cos(theta) + 0.0065)

    return { latitude: a_latitude, longitude: a_longitude }
}

function transformLatWithXY (x, y) {
    var pi = 3.14159265358979324
    var lat = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
    lat += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0
    lat += (20.0 * Math.sin(y * pi) + 40.0 * Math.sin(y / 3.0 * pi)) * 2.0 / 3.0
    lat += (160.0 * Math.sin(y / 12.0 * pi) + 320 * Math.sin(y * pi / 30.0)) * 2.0 / 3.0
    return lat
}

function transformLonWithXY (x, y) {
    var pi = 3.14159265358979324
    var lon = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
    lon += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0
    lon += (20.0 * Math.sin(x * pi) + 40.0 * Math.sin(x / 3.0 * pi)) * 2.0 / 3.0
    lon += (150.0 * Math.sin(x / 12.0 * pi) + 300.0 * Math.sin(x / 30.0 * pi)) * 2.0 / 3.0
    return lon
}

/**
 *  将WGS-84转为百度:
 */

export function transformWGS84toBaidu (longitude, latitude) {
    if (!isNaN(latitude) && !isNaN(longitude)) {
        var lat = parseFloat(latitude)
        var lon = parseFloat(longitude)
        let res = transformFromWGSToGCJ(lat, lon)
        let resBaidu = transformFromGCJToBaidu(res.latitude, res.longitude)
        return { longitude: resBaidu.longitude, latitude: resBaidu.latitude }
    }

}

// console.log(transformWGS84toBaidu(125.29530993019485,43.919921765753791),'transformWGS84toBaidu(125.55830145924251,43.662915391673486)')



// WEBPACK FOOTER //
// ./src/components/views/dpi1920_1080/components/LinYiMap/utils.js